import styled from 'react-emotion';
import Separator from '@ublend-npm/aulaui-next-web/Separator';
import { colors } from '@ublend-npm/aulaui-next-web/themes/default';

export const ListSeparator = styled(Separator)`
  background-color: ${colors.blackAlpha(0.12)};
`;

export default ListSeparator;
